<template>
  <rect
    :x="rectX"
    :y="rectY"
    :width="rectWidth"
    :height="rectHeight"
    :rx="borderRadius"
    :fill="ICON_COLORS[`bg_icon_${index + 1}`]"
  />
</template>
<script>
import { ICON_COLORS } from "./constant";
export default {
  name: "PointValueRect",
  props: {
    index: Number,
    value: String,
    borderRadius: String,
    point: Object,
    rectWidth: String,
    rectHeight: String,
  },
  data() {
    return {
      ICON_COLORS,
      x: 0,
      y: 0,
      rectX: 0,
      rectY: 0,
    };
  },
  mounted() {
    this.rectX = this.point.x - this.rectWidth / 2;
    this.rectY = this.point.y - this.rectHeight / 2 + 4;
    this.x = -11 + this.point.x;
    this.y = 8 + this.point.y;
  },
  watch: {
    point: {
      handler() {
        this.rectX = this.point.x - this.rectWidth / 2;
        this.rectY = this.point.y - this.rectHeight / 2 + 4;
        this.x = -11 + this.point.x;
        this.y = 8 + this.point.y;
      },
    },
  },
};
</script>